var map = {
	"./googleAnalytics-example.credentials.json": "./app/js/credentials/googleAnalytics-example.credentials.json",
	"./googleMaps-example.credentials.json": "./app/js/credentials/googleMaps-example.credentials.json",
	"./segmentIO-example.credentials.json": "./app/js/credentials/segmentIO-example.credentials.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/js/credentials sync recursive ^\\.\\/.*\\.credentials\\.json$";